import React from "react";
import { useHasScreenPermission } from "../../utils/screens-middleware";

function HasPermission({ screenId, children }) {
    const hashPermission = useHasScreenPermission(screenId);
    return hashPermission ? children : null;
}
export default React.memo(HasPermission);